import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { SearchParams } from '@synergy/models';

import {
    CANCEL_REQUEST_SUPPLIERS,
    RECEIVE_SUPPLIERS,
    REQUEST_SUPPLIERS,
    RESET_SUPPLIERS_SEARCH_PARAMS,
} from '../actions/supplier-actions';
import { Supplier } from './../models/supplier';

export interface SupplierReducerState {
    flat: PaginatedResponse<Supplier>;
    searchParams: SearchParams;
    requesting: boolean;
}

const initialSupplierReducerState: SupplierReducerState = {
    flat: { limit: 10, page: 0, total: 0, items: [] },
    searchParams: {},
    requesting: false,
};

export const supplierReducer = (
    state: SupplierReducerState = initialSupplierReducerState,
    action: AnyAction
): SupplierReducerState => {
    const { type, ...rest } = action;
    switch (type) {
        case REQUEST_SUPPLIERS: {
            return {
                ...state,
                requesting: true,
            };
        }

        case RECEIVE_SUPPLIERS: {
            return {
                ...state,
                flat: rest['suppliers'],
                requesting: false,
            };
        }

        case CANCEL_REQUEST_SUPPLIERS: {
            return {
                ...state,
                requesting: false,
            };
        }

        case RESET_SUPPLIERS_SEARCH_PARAMS: {
            return {
                ...state,
                searchParams: state.searchParams,
            };
        }

        default: {
            return {
                ...state,
            };
        }
    }
};
